import React from 'react';
import FormProvider, { FormContext } from './context';
import FormCheckbox from './FormCheckbox';
import FormNumber from './FormNumber';
import FormRadio from './FormRadio';
import FormSelect from './FormSelect';
import FormSpinner from './FormSpinner';
import FormText from './FormText';
import SubmitButton from './SubmitButton';

const Form = (props) => <FormText {...props} />;
Form.propTypes = FormText.propTypes;
Form.defaultProps = FormText.defaultProps;

// Inputs
Form.Checkbox = (props) => <FormCheckbox {...props} />;
Form.Checkbox.propTypes = FormCheckbox.propTypes;
Form.Checkbox.defaultProps = FormCheckbox.defaultProps;

Form.Number = (props) => <FormNumber {...props} />;
Form.Number.propTypes = FormNumber.propTypes;
Form.Number.defaultProps = FormNumber.defaultProps;

Form.Radio = (props) => <FormRadio {...props} />;
Form.Radio.propTypes = FormRadio.propTypes;
Form.Radio.defaultProps = FormRadio.defaultProps;

Form.Select = (props) => <FormSelect {...props} />;
Form.Select.propTypes = FormSelect.propTypes;
Form.Select.defaultProps = FormSelect.defaultProps;

Form.Spinner = (props) => <FormSpinner {...props} />;
Form.Spinner.propTypes = FormSpinner.propTypes;
Form.Spinner.defaultProps = FormSpinner.defaultProps;

Form.Text = (props) => <FormText {...props} />;
Form.Text.propTypes = FormText.propTypes;
Form.Text.defaultProps = FormText.defaultProps;

// Submit Button
Form.Submit = (props) => <SubmitButton {...props} />;
Form.Submit.propTypes = SubmitButton.propTypes;
Form.Submit.defaultProps = SubmitButton.defaultProps;

export { Form, FormProvider, FormContext };
